<template>
    <div>
      <div class="grid col-12 md:col-12" style="text-align: right; align: right">
        <div class="col-12 md:col-12" style="text-align: right; align: right">
          <Button
            @click="open2"
            label="Add New Driver"
            class="p-button-primary p-button-sm"
          />
        </div>
      </div>
      <div class="" style="height: 600px; overflow: scroll">
        <div class="col-12 md:col-12" v-if="search_loading1">
          <img
            src="https://gifimage.net/wp-content/uploads/2018/11/vehicle-loading-gif-8.gif"
            style="height: 80px; width: 100%"
          />
        </div>
        <div
          style="background-color: #173ea3; font-size: 12px; line-height: 0.9"
          class="card mb-0 grid mt-2"
          v-for="(data1, key) in driver_list"
          :key="key"
        >
          <div style="text-align: right;color: white;" class="col-12 md:col-12">
            <span>Status : </span><b>{{ data1.status }}</b>
          </div>
          <div class="col-12 md:col-2">
            <img
              style="max-width: 100px; height: 100px; border-radius: 20%"
              :src="
                data1.driver_photo != ''
                  ? data1.driver_photo
                  : 'https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o='
              "
            />
          </div>
          <div class="grid col-12 md:col-10" style="color:white;">
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-6">
                <span>Driver Name : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <span style="text-align: right"
                  ><b v-if="data1.driver_name">{{ data1.driver_name }}</b></span
                >
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-6">
                <span>Mobile Number : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <b>{{ data1.driver_mobile_number }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-6">
                <span>Email id : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <b>{{ data1.driver_email_id }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-6">
                <span>Gender : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <b>{{ data1.gender }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-6">
                <span>DOB : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <b>{{ data1.dob }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-6">
                <span>DL Number : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <b>{{ data1.dl_number }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-6">
                <span>Dl Expiry Date : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <b>{{ data1.dl_expiry_date }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-6">
                <span>accidental_history </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <b>{{ data1.accidental_history }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-6">
                <span>24/7 Avaibility </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <b>{{ data1.available24by7 }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-6">
              <div class="col-6 md:col-6">
                <span>Shift time</span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <b>{{ data1.shift }}</b>
              </div>
            </div>
            <div class="grid col-12 md:col-12">
              <div class="col-6 md:col-6">
                <span>Accidental Discription : </span>
              </div>
              <div class="col-6 md:col-6" style="text-align: right">
                <b>{{ data1.accidental_discription }}</b>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- //--------------------------------------------------------------------------------------------------------- -->
      <Dialog
            header="Add New Driver"
            v-model:visible="display2"
            :breakpoints="{ '960px': '75vw' }"
            :style="{ width: '70vw' }"
            :modal="true"
          >
              
          <div
          class="card mb-0"
          style=" font-size: 12px; line-height: 0.9;"
        >
        <div class="grid">
          <div class="col-6 md:col-6">
            
        <InputText type="text" v-model="search_number" style="width:100%;" placeholder="Enter Mobile Number" />
                
          </div>
          <div class="col-6 md:col-6">
              <Button label="Search"  class="p-button-primary p-button-sm" @click="search_driver()"/>
  
          </div>
        </div>
        <!-- {{driver_list}} -->
          <!-- {{data}} -->
          <div class="col-12 md:col-12" v-if="search_loading">
            <img src="https://gifimage.net/wp-content/uploads/2018/11/vehicle-loading-gif-8.gif" style="height:80px;width:100%" />
          </div>
          <br>
          <!-- {{search_status}} -->
          <div class="col-12 md:col-12" v-if="search_status==true">
              No Details Found
          </div>
          <div style="background-color: #173EA3; font-size: 12px; line-height: 0.9" class="card mb-0 grid" v-for="(data1,key) in driver_list1" :key="key">
              <!-- {{driver_list}} -->
            <div style="text-align: right;color: white;" class="col-12 md:col-12" >
              <span>Status : </span><b>{{ data1.status }}</b>
              <!-- {{data1}} -->
            </div>
              
            <div class="col-12 md:col-2">
              <img
                style="max-width: 70px; height: 70px; border-radius: 50%"
                :src="
                  data1.profile_image != ''
                    ? data1.profile_image
                    : 'https://media.istockphoto.com/vectors/no-image-available-icon-vector-id1216251206?k=6&m=1216251206&s=612x612&w=0&h=G8kmMKxZlh7WyeYtlIHJDxP5XRGm9ZXyLprtVJKxd-o='
                "
              />
            </div>
            <div class="grid col-12 md:col-10" style="color: white;">
            <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>Driver Name : </span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <span style="text-align: right"
                    ><b v-if="data1.first_name">{{ data1.first_name.toUpperCase() }}</b> <b v-if="data1.last_name">{{ data1.last_name.toUpperCase() }}</b></span
                  >
                </div>
              </div>
              <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>Mobile Number : </span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.mobile_number }}</b>
                </div>
              </div>
              <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>Email id : </span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.email_id }}</b>
                </div>
              </div>
              <!-- <div class="col-6 md:col-6">
                              <span>Model : </span><b>{{data.vehicledetails[0].model}}</b>
                          </div> -->
              <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>Gender : </span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.gender }}</b>
                </div>
              </div>
              <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>DOB : </span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.dob }}</b>
                </div>
              </div>
              <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>DL Number : </span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.dldetails.dl_number }}</b>
                </div>
              </div>
  
              <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>Dl Expiry Date : </span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.dldetails.dl_expiry_date }}</b>
                </div>
              </div>
  
              <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>accidental_history </span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.dldetails.accidental_history }}</b>
                </div>
              </div>
  
              <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>24/7 Avaibility </span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.dldetails.available24by7 }}</b>
                </div>
              </div>
              <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>Shift time from</span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.dldetails.shift_time_from }}</b>
                </div>
              </div>
              <div class="grid col-12 md:col-6">
                <div class="col-6 md:col-6">
                  <span>Shift time to</span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.dldetails.shift_time_to }}</b>
                </div>
              </div>
              <div class="grid col-12 md:col-12">
                <div class="col-6 md:col-6">
                  <span>Accidental Discription : </span>
                </div>
                <div class="col-6 md:col-6" style="text-align: right">
                  <b>{{ data1.dldetails.accidental_discription }}</b>
                </div>
              </div>
              <div class="grid col-12 md:col-12">
                <div class="col-12 md:col-12" style="text-align:right">
                    <Button  label="Add Driver" @click="add_driver_modal($event,data1)" class="p-button-primary p-button-sm" />
                </div>
              </div>
              
            </div>
          </div>
          </div>
          </Dialog>
          <Dialog
            header="Add Driver Details"
            v-model:visible="display3"
            :breakpoints="{ '960px': '75vw' }"
            :style="{ width: '30vw' }"
            :modal="true"
          >
          <div class="grid col-12 md:col-12" >
            <div class="grid">
              <div class="col-6 md:col-6">
                            Shift time from :
                    
                            
              </div>
              <div class="col-6 md:col-6" style="text-align:right;align:right">
                            <Calendar :showIcon="true" :showDate="false" :showTime="true"
                    hourFormat="12" :timeOnly="true" :showButtonBar="true" v-model="shift_time_from"></Calendar>
  
              </div>
              <div class="col-6 md:col-6">
                            Shift time to :
              </div>
              <div class="col-6 md:col-6" style="text-align:right;align:right">
                            
                            <Calendar :showIcon="true" :showDate="false" :showTime="true"
                    hourFormat="12" :timeOnly="true" :showButtonBar="true" v-model="shift_time_to"></Calendar>
              </div>
              <div class="col-6 md:col-6">
  
              </div>
            </div>
            <loading
              :active="isLoadingModel"
              :can-cancel="true"
              
              color="#173EA3"
              :is-full-page="fullPage"
            ></loading>
          </div>
          <template #footer>
            <Button label="Add" icon="pi pi-plus"  class="p-button-primary p-button-sm" @click="add_driver()"/>
  
              <Button
                label="Close"
                @click="close3"
                icon="pi pi-check"
                class="p-button-outlined p-button-sm"
              />
            </template>
          </Dialog>
  
  
    </div>
  </template>
  <script>
  import apis from "@/apis";
  import ProductService from "../../service/ProductService";
  import { FilterMatchMode } from "primevue/api";
  export default {
    data() {
      return {
          
        
        
        isLoadingModel:false,
        display: false,
        display1: false,
        display2:false,
        display3:false,
        search_loading:false,
        search_loading1:false,
        
        driver_list1:'',
        vehicle_details:[],
        shift_time_from:'',
        shift_time_to:'',
        search_status:false,
        search_number:'',
  
  
  
  
  
  
  
  
        dropdownValue: "",
        dropdownValues: [
          { name: "Active", code: "Active" },
          { name: "In Active", code: "In Active" },
          // {name: 'London', code: 'LDN'}
        ],
      
        delete_data: {},
        delete_data_index: "",
        file: [],
        limit: 10,
        filters: {},
        offset: 1,
        page_no: 1,
        driver_list: [],
        stop_name: "",
        isLoading: false,
       
        loading: false,
        fullPage: true,
        productDialog: false,
        table_data: [],
        groups: [],
        selectedgroup: null,
        name: "",
        status: "",
        location: "",
        mobile_number: "",
        parent_mobile_number: "",
        route_id: "",
        products: [],
        userlist: [],
        dropdownItems: [
          { name: "Active", value: "Active" },
          { name: "InActive", value: "InActive" },
          { name: "Deleted", value: "Deleted" },
        ],
        selectstatus: { name: "Active", value: "Active" },
        productService: null,
      };
    },
    props: ["vehicle_id", "client_ids", "owner_id"],
    methods: {
      close() {
        this.display = false;
          this.display1 = false;
          this.display2 = false;
      
      },
      close2() {
          this.display2 = false;
      
      },
      close3() {
          this.display3 = false;
      
      },
      open2() {
        this.driver_list1=[];
        this.display2 = true;
        
      },
      add_driver_modal(event,data) { 
        this.driver_id=data._id;
        this.display3 = true;
        
      },
      vehicleDriverList() {
        this.driver_list = [];
        var data = {
          owner_id: this.owner_id,
          vehicle_id: this.vehicle_id,
          client_id: this.client_ids,
        };
        var promise = apis.vehicleDriverList(data);
        promise.then((response) => {
          this.driver_list = response.data.data;
        });
      },
      time_formatDate(date_parm) {
        if (date_parm) {
          let date = new Date(date_parm);
          let hours = date.getHours();
          let minutes = date.getMinutes();
          // let ampm = '';
              var mid='AM';
              if(hours==0){ //At 00 hours we need to show 12 am
              hours=12;
              }
              else if(hours>12)
              {
              hours=hours%12;
              mid='PM';
              }
  
          let new_date = ("0" +hours).slice(-2) + ":" + ("0" +minutes).slice(-2) + " " + mid;
          // alert(dd)
          if (hours.toString() != "NaN") {
            //this.receipt_new_date = new_date;
            return new_date;
          } else {
            return date_parm;
          }
        }
      },
      async add_driver() {
        this.isLoadingModel = true;
        var data = {
          user_id: this.owner_id,
          driver_id: this.driver_id,
          shift:
            this.time_formatDate(this.shift_time_from) +
            " - " +
            this.time_formatDate(this.shift_time_to),
          vehicle_id: this.vehicle_id,
        };
        console.log(data);
        var promise = apis.addDriverVehicle(data);
        promise.then((response) => {
          this.isLoadingModel = false;
          if (response.data.status == true) {
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: response.data.message,
              life: 3000,
            });
            this.vehicleDriverList();
            this.display3 = false;
            this.display2 = false;
          } else {
            this.$toast.add({
              severity: "error",
              summary: "error",
              detail: response.data.message,
              life: 3000,
            });
            return false;
          }
        });
      },
      search_driver() {
        var data = {
          user_id: this.owner_id,
          search: this.search_number,
          type: "mobile",
          vehicle_id: this.vehicle_id,
        };
        this.search_loading = true;
        var promise = apis.searchDriverVehicleAdd(data);
        promise.then((response) => {
          this.search_loading = false;
          this.driver_list1 = response.data.data;
          // alert(search_result.length);
          if (this.driver_list1.length == 0) {
            this.search_status = true;
          } else {
            this.search_status = false;
          }
        });
      },
      openNew() {
        this.reset_details();
        this.product = {};
        this.products = [];
        this.submitted = false;
        this.productDialog = true;
      },
      hideDialog() {
        this.productDialog = false;
        this.submitted = false;
      },
      D_M_Y_formatDate(date_parm) {
        if (date_parm) {
          let date = new Date(date_parm);
          let dd = date.getDate();
          let mm = date.getMonth() + 1;
          let yyyy = date.getFullYear();
          let new_date = dd + "-" + mm + "-" + yyyy;
          // alert(dd)
          if (dd.toString() != "NaN") {
            //this.receipt_new_date = new_date;
            return new_date;
          } else {
            return date_parm;
          }
        }
      },
      initFilters() {
        this.filters = {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        };
      },
    },
    watch: {},
    async mounted() {
      await this.vehicleDriverList();
    },
    async created() {
      this.productService = new ProductService();
      this.initFilters();
      //
    },
  };
  </script>
  